export default "__VITE_ASSET__VfXllWDy__"